import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "../common/Header/Header";
import { useAppSelector } from "../../redux/features/redux-hooks";
import Footer from "../common/Footer/Footer";
// import { useCart } from "../../context/CartContext";
import WhatsAppWidget from "../common/WhatsAppWidget/WhatsAppWidget";

const DefaultLayout = () => {
  const basicUserInfo = useAppSelector(
    (state) => state.authState.basicUserInfo
  );
  // const { initializeCart } = useCart();

  useEffect(() => {
    if (basicUserInfo) {
      // initializeCart();
    }
  }, [basicUserInfo]); // Re-run when auth state changes

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      <WhatsAppWidget/>
    </>
  );
};

export default DefaultLayout;
